const forbiddenSigns = ["--", ";;", "-;", ";-"];

// Проверка валидности areaCodes
export const checkIsValidAreaCodes = (value: string): boolean => {
  const errorTestOk = /[^0-9-;]/g.test(value);
  const hasForbidden = forbiddenSigns.some((sign) => value.includes(sign));
  const startsWithSemi = value.startsWith(";");
  const startsWithDash = value.startsWith("-");
  const isCodesValidByCountryCode = true; // TODO Evgeniy Sumaev - Свете задал вопрос где брать код страны. Вроде как нужно делать поиск направлений по destinationTypeId === 8, а потом там по коду страны находить страну и брать код оттуда. Пока поиск по destinationTypeId не работает
  // console.table({ value, errorTestOk, hasForbidden, startsWithSemi, startsWithDash });
  if (
    errorTestOk ||
    hasForbidden ||
    startsWithSemi ||
    startsWithDash ||
    !isCodesValidByCountryCode
  ) {
    return false;
  }
  // Проверка на единственность тире внутри каждого кода
  const withoutMultipleDashes = value.split(";").every((item) => item.split("-").length < 3);
  return withoutMultipleDashes;
};

// Проверка в диапазонах, чтобы конечный был больше начального. Вынесена отдельно, т.к. нужна только при сохранении (если сделать при редактировании, то будет неудобно и неочевидно т.к. при вводе будет всегда ошибка)
export const checkIsValidAreaCodesRange = (value: string): boolean => {
  const isBaseValid = checkIsValidAreaCodes(value);
  if (isBaseValid) {
    const codes = value.split(";");
    const isValidRange = codes.every((code) => {
      const range = code.split("-");
      if (range.length === 1) {
        return true;
      }
      return Number(range[0]) < Number(range[1]);
    });
    return isValidRange;
  }
  return false;
};
